import { X } from 'lucide-react';

/**
 * Full-screen modal that shows either the event's custom T&C or the default
 * Unight house rules. Click outside or X to close.
 *
 * Props:
 *   open, onClose    — modal state
 *   eventTitle       — used in the modal heading when the event has custom terms
 *   termsText        — raw <pre>-rendered T&C text
 *   isCustomTerms    — true when the event has custom terms (vs. default fallback)
 */
export default function RsvpTermsModal({ open, onClose, eventTitle, termsText, isCustomTerms }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center px-4"
      onClick={onClose}
      data-testid="rsvp-terms-modal"
    >
      <div
        className="bg-[#0A0A0A] border border-zinc-800 max-w-2xl w-full max-h-[80vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-5 border-b border-zinc-800 sticky top-0 bg-[#0A0A0A]">
          <h3 className="font-['Josefin_Sans'] text-xl text-white">
            {isCustomTerms ? `${eventTitle} — TERMS` : 'UNIGHT TERMS'}
          </h3>
          <button
            onClick={onClose}
            className="text-zinc-500 hover:text-white"
            data-testid="rsvp-terms-modal-close"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-5">
          <pre className="text-zinc-300 text-sm whitespace-pre-wrap font-sans leading-relaxed">
            {termsText}
          </pre>
        </div>
      </div>
    </div>
  );
}
